import { useEffect, useRef } from 'react';

import { useAppSelector } from '@/Application/Hooks/Redux';
import {
  createEventPayload,
  createProductObj,
  getDeviceFromUrl
} from '@/modules/perseo-billing/utils';
import { sendEventByDevice } from '@/modules/shared/utils/gtmEvents/sendEvents/sendBillingEvents';

export const useSendProductsBillingGtm = () => {
  const cart = useAppSelector((state) => state?.cart?.data);
  const gtmEventSentRef = useRef(false);

  useEffect(() => {
    const sendProductsFromBillingGtm = (): void => {
      if (gtmEventSentRef.current || !cart || !cart?.lineItems) return;

      const device = getDeviceFromUrl();
      const isWebView = device !== 'web';

      const products = cart?.lineItems;
      const productsObj = createProductObj(products, isWebView);

      const totalPrice = cart?.totalPrice?.centAmount;
      const payload = createEventPayload(
        productsObj,
        isWebView,
        totalPrice,
        cart
      );

      const eventName = isWebView ? 'add_payment_info' : null;

      sendEventByDevice({
        eventName: eventName ?? '',
        payload
      });
      gtmEventSentRef.current = true;
    };

    sendProductsFromBillingGtm();
  }, [cart]);
};
